import React, { useState } from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { GetNewButton } from "@coworker/apprestructured/src/testbuy/components/SwipeableTestbuyListViewItem/GetNewButton/GetNewButton";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import { ChangeWithButton } from "@coworker/apprestructured/src/testbuy/components/SwipeableTestbuyListViewItem/ChangeWithButton/ChangeWithButton";
import { SwipeableCard } from "@coworker/apprestructured/src/shared/components/SwipeableCard/SwipeableCard";
import { TestbuyListViewItem } from "@coworker/apprestructured/src/testbuy/components/TestbuyListViewItem/TestbuyListViewItem";
import { useSwipeable } from "react-swipeable";

interface SwipeableTestbuyItemCardProps {
  onGetNewItemClick: () => void;
  item: Item;
  testbuyItem: TestBuyProductWithCriteria;
  onChangeWithClick: () => void;
  navigationUrl: string;
}

type SwipeDirection = "left" | "right" | "";

export const SwipeableTestbuyListViewItem = ({
  item,
  testbuyItem,
  onGetNewItemClick,
  onChangeWithClick,
  navigationUrl,
}: SwipeableTestbuyItemCardProps) => {
  const [swipeDirection, setSwipeDirection] = useState<SwipeDirection>("");
  const swipeTimeout = React.useRef<number>(0);

  const handlers = useSwipeable({
    onSwiped: () => {
      if (swipeTimeout.current) clearTimeout(swipeTimeout.current);
      swipeTimeout.current = window.setTimeout(() => {}, 100);
    },
    onSwipedLeft: () => {
      setSwipeDirection(swipeDirection === "right" ? "" : "left");
    },
    onSwipedRight: () => {
      if (swipeDirection === "left") {
        setSwipeDirection("");
      } else {
        setSwipeDirection("right");
      }
    },
    trackMouse: true,
  });

  return (
    <SwipeableCard
      handlers={handlers}
      swipeDirection={swipeDirection}
      content={
        <TestbuyListViewItem
          navigationUrl={navigationUrl}
          item={item}
          testbuyItem={testbuyItem}
        />
      }
      actions={
        <>
          <GetNewButton
            onClick={onGetNewItemClick}
            swipeDirection={swipeDirection}
            setSwipeDirection={setSwipeDirection}
          />
          <ChangeWithButton
            onClick={onChangeWithClick}
            swipeDirection={swipeDirection}
            setSwipeDirection={setSwipeDirection}
          />
        </>
      }
    />
  );
};
